import React from 'react'
import {Spin, message, Button, } from 'antd';
import EssaModal from '@components/EssaModal/EssaModal';
import Lang from "@components/Lang/Lang";
import ModalOrderDetailsAction from "./ModalOrderDetail.action";
import OrderDetails from './OrderDetails';
import PropTypes from 'prop-types';
/**
 * 打开订单详情 组件
 *
 * @author FJJ
 * @version 1.0
 *
 * History:
 * Date      Version Remarks
 *
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * */
export default class ModalOrderDetail extends React.Component {
    static propTypes = {
        icon: PropTypes.string.isRequired,
        id:  PropTypes.number.isRequired, // https://remixicon.cn/ 图标
    }
    static defaultProps = {
        icon:'',// https://remixicon.cn/ 图标 及样式
        id:"",// https://remixicon.cn/ 图标
    };
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            loading: false,
            list:[],//行
            extra: {},
            selectOrder:{},
            showTip: false,// 批量提示出库提示
            showTimeTips:false,
        }
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    /**
     * 获取单个出库详情*/
    getDeliveryListInfo(id) {
        this.loading(true)
        this.handleCloseDetails(true)
        ModalOrderDetailsAction.postDeliveryListInfo({
            id,
        }).then(res => {
            this.loading(false)
            if (res.data.success && res.data.valid) {
                let order = res.data.model || {}
                this.setState({
                    selectOrder: {
                        ...order,
                        ids: [order.id],
                    },
                    extra: res.data.extra,
                })
            } else {
                message.info(res.data.message);
            }
        })
    }
    handleCloseDetails(flag=false){
        this.setState({
            showDetails:flag
        })
    }
    render() {
        const { icon,id,children } = this.props;
        const {loading, showDetails, extra,selectOrder, } = this.state;
        return (<>
                {children?<span onClick={()=>this.getDeliveryListInfo(id)}>{children}</span>:<i className={icon} onClick={()=>this.getDeliveryListInfo(id)}></i>}
                {/*出库详情弹窗*/}
                {showDetails&&<EssaModal title={Lang({id:"DingDanXiangQing",default:"订单详情"})}
                                        open={showDetails}
                                        width={750}
                                        onCancel={()=>this.handleCloseDetails()}
                                        footer={[
                                           <Button onClick={() => this.handleCloseDetails()} key={"close"}>
                                              {Lang({id:"GuanBi",default:"关闭"})}
                                           </Button>,
                                       ]}>
                    <Spin spinning={loading}>
                       {selectOrder&&selectOrder.orderNumber&&extra.currencySymbol&&<OrderDetails
                           data={selectOrder}  />}
                    </Spin>
                </EssaModal>}

            </>
        )
    }
}